export default __webpack_public_path__ + "static/media/nepal_post-covid.b5aaed7f.jpeg";